import Vue from 'vue';
import Vuex from 'vuex';
import App from './App.vue';
import router from './router';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueSocketIO from 'vue-socket.io';
import axios from 'axios'
import './custom.scss';

const fb = require('./firebaseConfig.js');

Vue.config.productionTip = false;

Vue.prototype.$http = axios;

Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

let store = new Vuex.Store({
  state: {
    currentUser: {},
    socketConnected: false,
    clock: '',
    game: {
      assignedTickets: [],
      numbers: [],
      bingoClaims: [],
      lineClaims: [],
      participantIds: [],
      participants: []
    },
    room: {}
  },
  getters: {
    currentUser: state => state.currentUser,
  },
  mutations: {
    setCurrentUser(state, user) {
      Vue.set(state, 'currentUser', user);
    },

    SOCKET_connect(state) {
      Vue.set(state, 'socketConnected', true);
    },

    SOCKET_disconnect(state) {
      Vue.set(state, 'socketConnected', false);
    },

    SOCKET_game(state, message) {
      Vue.set(state, 'game', message);
    },

    SOCKET_room(state, message) {
      Vue.set(state, 'room', message);
    },
  }
});

Vue.use(new VueSocketIO({
  debug: false,
  connection: process.env.VUE_APP_API_URL,
  vuex: {
      store,
      actionPrefix: 'SOCKET_',
      mutationPrefix: 'SOCKET_'
  }
}));

let app;
fb.auth().onAuthStateChanged(() => {
  if (fb.auth().currentUser && fb.auth().currentUser.displayName) {
    fb.usersCollection.doc(fb.auth().currentUser.uid).get()
    .then((doc) => {
      if (doc.exists) {
        store.commit('setCurrentUser', doc.data());
      }
    })
  }
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app');
  }
});
